
import {
  computed,
  defineComponent,
} from 'vue';

export default defineComponent({
  props: {
    textAlign: {
      type: String,
      required: false,
      default: () => 'center',
    },
    color: {
      type: String,
      required: false,
      default: () => 'dark',
    },
    fontSize: {
      type: String,
      required: false,
      default: () => 'regular',
    },
    colorLg: {
      type: String,
      required: false,
      default: () => 'dark',
    },
  },
  setup(props) {
    const classes = computed(() => {
      const textClasses = [];

      textClasses.push(`text-${props.textAlign}`);
      textClasses.push(`color-${props.color}`);
      textClasses.push(`color-lg-${props.colorLg}`);
      textClasses.push(`fs-${props.fontSize}`);

      return textClasses;
    });

    return {
      classes,
    };
  },
});
